import { useRef, useState, useEffect } from 'react';

import classes from './classes.module.scss';

import {
  cacheBustUrl
} from 'shared/utils/Utils';

const Thumbnail = props => {
  const {
    colDef,
    data,
    lastUpdate
  } = props;

  // ref to be used for img tag
  const imgRef = useRef();

  // img src for thumbnail (might be determined with async function)
  const [imgSrc, setImgSrc] = useState(null);

  const loadImage = async () => {
    let src;
    if (typeof colDef.thumbnail === 'string') {
      src = colDef.thumbnail;
    } else {
      // assume colDef.thumbnail is a function that returns the src
      src = colDef.thumbnail(data);
      if (src instanceof Promise) {
	src = await src;
      }
    }

    if (src && mountedRef.current) {
      setImgSrc(src);
    }
  }

  // track whether the component is mounted.
  // the colDef.thumbnail function may be async,
  // and might return after the component has unmounted,
  // in which case we'll want to abort before setting the state
  const mountedRef = useRef(true);

  useEffect(() => {
    loadImage();

    return () => {
      mountedRef.current = false;
    }
  }, []);

  // cache bust
  useEffect(() => {
    if (imgSrc) {
      let url = cacheBustUrl(imgSrc, lastUpdate);
      setImgSrc(url);
    }
  }, [lastUpdate]);

  const onError = async () => {
    if (colDef.thumbnailFallback) {
      imgRef.current.src = await colDef.thumbnailFallback(data);
    }
  }

  return (
    <div className={classes.thumbnailWrapper}>
      <img
	ref={imgRef}
	className={classes.thumbnail}
	src={imgSrc}
	onClick={() => colDef.onThumbnailClick(data)}
	onError={onError}
      />
    </div>
  );
}

export default Thumbnail;
